module.exports = __webpack_public_path__ + "static/img/pcTitle1.443b6d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcTitle1.png
// module id = ybKA
// module chunks = 1